export default __webpack_public_path__ + "static/media/companydybg.ba13be9a.png";